import _extends from 'babel-runtime/helpers/extends';

import { mapGetters } from 'vuex';
import ScencNodeTrees from './SceneNodeTrees.vue';

export default {
  components: {
    ScencNodeTrees: ScencNodeTrees
  },
  data: function data() {
    return {
      dialogProps: {
        visible: false,
        title: '场景节点选择',
        modalAppendToBody: true,
        appendToBody: true,
        modal: true,
        width: '400px',
        closeOnPressEscape: false,
        closeOnClickModal: false
      },
      selectTarget: null
    };
  },

  computed: _extends({}, mapGetters({
    currentSceneTreeIncludeScene: 'workspace/game/currentSceneTreeIncludeScene'
  }), {
    treeProps: function treeProps() {
      return {
        data: this.currentSceneTreeIncludeScene,
        props: {
          children: 'children',
          label: 'label'
        },
        currentNodeKey: this.selectTargetId,
        highlightCurrent: true,
        nodeKey: 'uuid'
      };
    },
    selectTargetId: function selectTargetId() {
      return this.selectTarget ? this.selectTarget.uuid : this.selectTarget;
    }
  }),
  methods: {
    openDialog: function openDialog() {
      this.dialogProps.visible = true;
    },
    closeDialog: function closeDialog() {
      this.dialogProps.visible = false;
    },
    handleCurrentChange: function handleCurrentChange(node) {
      this.selectTarget = node;
    },
    okHandler: function okHandler() {
      if (!this.selectTarget) {
        return this.$message({
          type: 'warning',
          message: '请选择节点'
        });
      }
      this.$emit('selectNode', this.selectTarget);
      this.closeDialog();
    }
  }
};